<template>
  <div class="comments-tab">
    <Notes
      v-if="!isCommentsActive"
      :isEditMode="isEditMode"
      :revNotes="rev.notes"
      :modelName="modelName"
      @notesChanged="notesChanged"
    />
    <CommentsAddon
      :isCommentsActive="isCommentsActive"
      :canEdit="canEdit"
      :modelType="modelType"
      :modelName="modelName"
      :modelId="modelId"
      :siteId="siteId"
      :submitCommentTestId="submitCommentTestId"
      :isEditMode="isEditMode"
      :textAreaTid="textAreaTid"
    >
      <div class="d-flex flex-row mb-2" slot="activity-actions">
        <Button
          fab
          :outlined="!isCommentsActive"
          class="mr-2"
          size="x-small"
          icon="mdi-comment-text"
          data-testid="RevView-tab-comments"
          :color="isCommentsActive ? 'primary' : 'grey'"
          @click="isCommentsActive = true"
        />
        <Button
          fab
          :outlined="isCommentsActive"
          size="x-small"
          icon="mdi-clipboard-text"
          data-testid="RevView-tab-notes"
          :color="!isCommentsActive ? 'primary' : 'grey'"
          @click="isCommentsActive = false"
        />
      </div>
    </CommentsAddon>
  </div>
</template>
<script>
import Notes from '@/components/Core/Notes.vue'
import CommentsAddon from '@/components/Core/Comments/CommentsAddon.vue'
import Button from '@/components/UI/Button'
import _ from 'lodash'

export default {
  components: {
    CommentsAddon,
    Button,
    Notes,
  },
  props: {
    canEdit: {
      type: Boolean,
      required: true,
      default: false,
    },
    isEditMode: {
      type: Boolean,
      required: true,
      default: false,
    },
    modelId: {
      type: String,
      required: true,
    },
    modelType: {
      type: String,
      required: false,
    },
    modelName: {
      type: String,
      required: true,
    },
    submitCommentTestId: {
      type: String,
      required: true,
      default: '',
    },
    siteId: { type: String, required: true },
    rev: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },
  },

  data() {
    return {
      isCommentsActive: true,
    }
  },

  computed: {
    textAreaTid() {
      return `commentAddition-textArea-${_.camelCase(this.modelName)}`
    },
  },

  methods: {
    notesChanged(notes) {
      this.$emit('notesChanged', notes)
    },
  },
}
</script>
<style lang="scss" scoped>
.comments-tab {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
